import {InvoiceLine} from '../types';
import {VAT} from '../../services';

export const invoiceOrderTotal = (invoiceOrder: {lines: InvoiceLine[]}, date: Date) => (
  invoiceOrder.lines
    .map(line => {
      const amount = (typeof line.amount === 'string') ? parseFloat(line.amount.replace(',', '.')) : line.amount;
      const divider = line.vatIncluded ? 1 + VAT.fraction(date) : 1;
      return amount ? (amount) / divider : 0;
    })
    .reduce((acc, amount) => acc + amount, 0)
);

export const invoiceOrderTotalWithVat = (invoiceOrder: {lines: InvoiceLine[], [key: string]: unknown}, date: Date) => (
  invoiceOrderTotal(invoiceOrder, date)) * (1 + VAT.fraction(date)
);

export const calcLineTotals = (values: {lines: InvoiceLine[]}, date: Date) => {
  const total = invoiceOrderTotal(values, date);
  const totalVAT = total * (1 + VAT.fraction(date));
  const VATValue = totalVAT - total;

  return {total, VAT: VATValue, totalVAT};
};
